import React from "react";
import { Link } from "react-router-dom";
import "../css/App.css";

import useUtils from "./hooks/useUtils";

export default (props) => {
  /*  const pol_0km =
    props.descuentos &&
    props.descuentos.descuentos &&
    props.descuentos.descuentos[0].Pol_0km;
  const pol_0km_Gastos =
    props.descuentos &&
    props.descuentos.descuentos &&
    props.descuentos.descuentos[0].Pol_0km_Gastos; */
  /*   const pol_Usados = props.descuentos.descuentos[0].Pol_Usados;
  const pol_Usados_Gastos = props.descuentos.descuentos[0].Pol_Usados_Gastos; */

  const ruta = "https://store.autoprana.com.ar/img/";
  const onSeleccionVehiculo = () => {
    window.scroll({
      top: 0,
    });

    props.onSeleccionVehiculo(props.vehiculo);
  };

  function sendWhatsappFer(modelo, chasis) {
    let texto = `https://wa.me/5491151060558?text=Hola, me estoy comunicando de Prana y estoy interesado en el modelo ${modelo}, chasis ${chasis} tipo 0KM. Mi consulta es:%20`;

    window.location.href = texto;
  }

  let leyendaPrecioDolar =
    props.vehiculo.moneda === "U$S" ? "(Dolar Banco Nación)" : "";

  const { loadNoImage } = useUtils(props.vehiculo.foto0);

  console.log(props.descuentos, "descuentos");
  console.log(props.vehiculo, "vehiculo");

  return (
    <div className="center-align">
      <div className="card hoverable">
        <div className="valign-wrapper">
          <div
            className="card-image waves-effect waves-block waves-light valign-wrapper tarjeta"
            style={{ height: "11em" }}
          >
            <img
              className="activator"
              src={ruta + props.vehiculo.foto0}
              style={{ width: "100%" }}
              alt="vehiculo"
              onError={(e) => loadNoImage(e)}
            />
          </div>
        </div>
        <div className="card-content">
          <ul>
            <li className="li-version truncate left-align">
              <b>{props.vehiculo.version}</b>
            </li>
            <li className="li-version truncate left-align">
              Chasis: {props.vehiculo.vin}
            </li>
            <li className="li-version truncate left-align">
              Color: {props.vehiculo.color}
            </li>
            <li className="li-version truncate left-align">
              <b>{props.vehiculo.moneda}</b>{" "}
              {Intl.NumberFormat("es-AR", {
                currency: "ARS",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }).format(props.vehiculo.precio)}
            </li>
            {/*    <li className="li-version truncate left-align">
              <span style={{ color: "red", fontWeight: "bold" }}>
                DESCUENTO ONLINE <br></br>
                {Intl.NumberFormat("es-AR", {
                  style: "currency",
                  currency: "ARS",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(
                  props.vehiculo.precio * pol_0km +
                    props.vehiculo.pat_emp * pol_0km_Gastos
                )}
              </span>
            </li> */}
            <li
              className="li-version truncate left-align"
              style={{ fontWeight: "bold", fontSize: "12px" }}
            >
              {leyendaPrecioDolar}
            </li>
          </ul>
          <Link
            className="btn red accent-4 waves-effect hoverable white-text"
            style={{
              paddingLeft: "35px",
              paddingRight: "35px",
              /* marginLeft: "5%", */
              marginTop: "5px",
            }}
            onClick={onSeleccionVehiculo}
            to="/gastos"
          >
            <b>Reservar</b>
          </Link>
          {/* <Link
            className="btn green accent-4 waves-effect hoverable white-text"
            style={{ marginLeft: "5%", width: "140px", marginTop: "5px" }}
            onClick={() =>
              sendWhatsappFer(props.vehiculo.version, props.vehiculo.vin)
            }
          >
            Contactar
            <img
              src="https://store.autoprana.com.ar/img/imgSitio/whatsapp.png"
              style={{ paddingLeft: "5%" }}
              alt="whatsapp"
              width="16%"
            ></img>
          </Link> */}
          <div className="row row-activator" style={{ marginBottom: 0 }}>
            <br />
            <span
              className="activator left"
              style={{
                fontWeight: "bold",
                cursor: "pointer",
                fontSize: "12px",
              }}
            >
              Info - click aqui
            </span>
          </div>
        </div>
        <div className="card-reveal left-align">
          <ul>
            <span className="card-title grey-text text-darken-4">
              {props.vehiculo.version}
              <i className="material-icons right">close</i>
            </span>

            <p>Chasis: {props.vehiculo.vin}</p>
            <p>Año: {props.vehiculo.anio}</p>
            <p>
              <span>Precio:</span>
              {props.vehiculo.moneda} {props.vehiculo.precio}
            </p>
            <p>Color: {props.vehiculo.color}</p>
            <p>Tipo: {props.vehiculo.tipo}</p>
            <p>Transmision: {props.vehiculo.transmision}</p>
          </ul>
        </div>
      </div>
    </div>
  );
};
